















































































import Vue from "vue";
import * as R from "ramda";

import PERSPECTIVES from "@/graphql/projects/Perspectives.gql";
import PERSPECTIVE_CREATE from "@/graphql/projects/PerspectiveCreate.gql";
import PERSPECTIVE_UPDATE from "@/graphql/projects/PerspectiveUpdate.gql";
import PERSPECTIVE_DELETE from "@/graphql/projects/PerspectiveDelete.gql";
import {
  Perspectives_perspectives,
  Perspectives_perspectives_edges,
  Perspectives_perspectives_edges_node,
  Perspectives
} from "../../api-types";
import { ApolloQueryResult } from "apollo-client";

export default Vue.extend({
  name: "PerspectiveDialog",
  props: {
    viewer3d: {
      type: String,
      default: null
    },
    hdrViewer: {
      type: String,
      default: null
    },
    gisWeb: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      loading: "initial",
      availablePerspectives: [] as Perspectives_perspectives_edges[],
      removedPerspectives: [] as Perspectives_perspectives_edges[],
      addedPerspectives: [] as { node: { name: string; path: string } }[],
      newPerspective: { node: { name: "", path: "" } }
    };
  },
  apollo: {
    perspectives: {
      query: PERSPECTIVES,
      variables: function() {
        if (this.viewer3d) {
          return { viewer3d: this.viewer3d };
        } else if (this.hdrViewer) {
          return { hdrViewer: this.hdrViewer };
        } else if (this.gisWeb) {
          return { gisWeb: this.gisWeb };
        }
      },
      result({ data }: ApolloQueryResult<Perspectives>) {
        this.availablePerspectives = data!.perspectives!.edges!.slice(
          0
        ) as Perspectives_perspectives_edges[];
        this.loading = "";
      }
    }
  },
  computed: {
    listedPerspectives(): any {
      return [...this.availablePerspectives, ...this.addedPerspectives];
    }
  },
  methods: {
    add() {
      this.addedPerspectives.push(R.clone(this.newPerspective));
      this.newPerspective.node.name = "";
      this.newPerspective.node.path = "";
    },
    remove(index: number) {
      const item = this.listedPerspectives[index];
      if (!item.node.id) {
        index = index - this.availablePerspectives.length;
        this.addedPerspectives.splice(index, 1);
      } else {
        this.removedPerspectives.push(this.availablePerspectives[index]);
        this.availablePerspectives.splice(index, 1);
      }
    },
    async save() {
      this.loading = "save";
      for (const perspective of this.addedPerspectives) {
        await this.createPerspective(perspective.node);
      }
      this.addedPerspectives = [];
      for (const perspective of this.availablePerspectives) {
        await this.updatePerspective(perspective.node);
      }
      for (const perspective of this.removedPerspectives) {
        await this.deletePerspective(perspective.node);
      }
      this.removedPerspectives = [];
      await this.$apollo.queries.perspectives.refetch();
      this.$emit("close");
    },
    createPerspective(perspective: { name: string; path: string }) {
      return this.$apollo.mutate({
        mutation: PERSPECTIVE_CREATE,
        variables: {
          input: {
            name: perspective.name,
            path: perspective.path,
            routeName: this.formatName(perspective!.name),
            hdrViewer: this.hdrViewer ? this.hdrViewer : null,
            viewer3d: this.viewer3d ? this.viewer3d : null,
            gisWeb: this.gisWeb ? this.gisWeb : null
          }
        }
      });
    },
    updatePerspective(
      perspective: Perspectives_perspectives_edges_node | null
    ) {
      return this.$apollo.mutate({
        mutation: PERSPECTIVE_UPDATE,
        variables: {
          input: {
            id: perspective!.id,
            path: perspective!.path,
            routeName: this.formatName(perspective!.name)
          }
        }
      });
    },
    deletePerspective(
      perspective: Perspectives_perspectives_edges_node | null
    ) {
      return this.$apollo.mutate({
        mutation: PERSPECTIVE_DELETE,
        variables: {
          input: {
            id: perspective!.id
          }
        }
      });
    },
    formatName(name: string) {
      return name
        .toLowerCase()
        .replace(/ü/g, "ue")
        .replace(/ö/g, "oe")
        .replace(/ä/g, "ae")
        .replace(/ /g, "-");
    }
  }
});
